import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { Article } from "models";

export const useToggleArticleDisableMutation = () => {
  const { mutateAsync, isPending } = useTypedMutation<Article, void>({
    mutationFn: async article => {
      await ApiInstance.post("/articles/update", { ...article, disabled: !article.disabled }, ENV.dealerBaseURL);
    },
    onSuccess: () => null
  });

  return { toggleDisableMutation: mutateAsync, isPending };
};
